import axios from "axios";
import React, { useContext, useEffect, useState } from "react";

import { message } from "antd";
import { Modal, Toast } from "antd-mobile";
import $ from "jquery";
import PsContext from "../../context";
import ModuleAccess from "../../context/moduleAccess";
import { MOB_ICONS, MuiModalWindow, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import UpcomingTimeTable from "../upcomingTimeTable";
import AttendancePercentage from "./attendancePercentage";
import ShortLinks from "./shortLinks";
import TodayDayOrder from "./todayDayOrder";
import WelcomeProfile from "./welcomeProfile";
import AttendancePercentageModal from "./attendancePercentageModal";
import { Card, Col, Row } from "react-bootstrap";
import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";

const Home = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState([]);
  const [timeTable, setTimeTable] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isDemo, setIsDemo] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [birthdayWish, setBirthdayWish] = useState([]);
  const [showPercentage, setShowPercentage] = useState(false);
  const [attApproved, setAttApproved] = useState(true);

  useEffect(() => {
    //loadTimeTable();
    loadAttendanceApproved();
  }, []);

  const userPhoto = () => {
    let gender = upperCase(context.user.gender);
    if (gender == "MALE") return MOB_ICONS.MAN_256;
    else if (gender == "FEMALE") return MOB_ICONS.WOMAN_256;
  };

  const loadAttendanceApproved = () => {
    setLoader(true);
    const form = new FormData();
    form.append("college_uuid", context.user.college_uuid);
    form.append("course_uuid", context.user.course_uuid);
    form.append("student_uuid", context.user.student_uuid);
    form.append("semester", context.user.semester);
    axios.post(ServiceUrl.STUDENTS.MY_ATTENDANCE_APPROVED, form).then((res) => {
      if (res["data"].status == "1") {
        if (res["data"]?.data?.is_approved == "0") {
          setAttApproved(false);
        }
      }
      setLoader(false);
    });
  };
  const loadTimeTable = () => {
    setLoader(true);
    setHoliday([]);
    setTimeTable([]);
    const form = new FormData();
    form.append("type", "today");
    axios.post(ServiceUrl.STUDENTS.MY_TIME_TABLE, form).then((res) => {
      if (res["data"].status == "1") {
        setTimeTable(res["data"].data);
      } else {
        setHoliday(res["data"].data);
      }
      setLoader(false);
    });
  };

  const leaveType = (lt) => {
    if (upperCase(lt) == "P" || upperCase(lt) == "ML" || upperCase(lt) == "OD")
      return <span className="text-success">{upperCase(lt)}</span>;
    else if (
      upperCase(lt) == "A" ||
      upperCase(lt) == "LA" ||
      upperCase(lt) == "L"
    )
      return <span className="text-danger">{upperCase(lt)}</span>;
    else return <span>-</span>;
  };

  const getAttRows = () => {
    let rv = [];
    for (let i = 1; i <= context.user.att_hour_per_day; i++) {
      let m = timeTable.find((item) => item.hour_value == i);
      rv.push(
        <tr>
          <th scope="row">
            <span className="bg-red-50 text-danger p-1 rounded-circle">
              H{i}
            </span>
          </th>

          <td>
            <a>{m?.subject_name}</a>
          </td>
          <td>{leaveType(m?.leave_type)}</td>
        </tr>
      );
    }
    return rv;
  };

  const handleOpen = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    //listRequestType();
  }, []);

  useEffect(() => {
    handleGetBirthdayWish();
  }, []);

  const closeModal = () => {
    setShowModal(false);
  };

  const handleGetBirthdayWish = (e) => {
    context.setLoader(true);
    var form = new FormData();
    form.append("uuid", context.user.uuid);
    form.append("mobile", context.user.mobile);
    form.append("registerno", context.user.registerno);
    form.append("dob", context.user.dob);
    axios.post(ServiceUrl.STUDENTS.BIRTHDAY_WISH_TEMPLATE, form).then((res) => {
      if (res["data"].status == "1" && res["data"].is_birthday == "1") {
        let d = res["data"].data;
        setBirthdayWish(d);
        setShowModal(true);
      } else {
        console.error(res["data"].message || "Error");
      }
      context.setLoader(false);
    });
    context.setLoader(false);
  };

  const listRequestType = () => {
    setLoader(true);
    axios.get(ServiceUrl.REQUEST.SERVICE_TYPE).then((res) => {
      if (res["data"].status == "1") {
        setServiceType(res["data"].data);
        setLoader(false);
      }
    });
    setLoader(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    axios
      .post(ServiceUrl.REQUEST.ADD_REQUEST, $("#service_request").serialize())
      .then((res) => {
        if (res["data"].status == "1") {
          message.success(res["data"].message || "Saved");
          setOpenModal(false);
          setLoader(false);
        } else {
          message.error(res["data"].message || "Error");
          setLoader(false);
        }
      });
  };

  return (
    <>
      <Header title="Dashboard" noBack />

      <div data-aos="zoom-in">
        <div className="container py-md-3">
          <Row>
            <Col md={4} className="mb-3">
              <WelcomeProfile />
            </Col>
            <Col md={4} className="mb-3">
              <List
                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                <TodayDayOrder />

                <ModuleAccess
                  module="stu_mob_view_att_percentage"
                  action="action_read"
                >
                  <>
                    <Divider />
                    <ListItem
                      onClick={(e) => setShowPercentage(true)}
                      secondaryAction={
                        <IconButton edge="end">
                          <ArrowForwardIosOutlinedIcon />
                        </IconButton>
                      }
                    >
                      <ListItemText primary="My Attendance Percentage" />
                    </ListItem>
                  </>
                </ModuleAccess>
              </List>
            </Col>
          </Row>

          {!attApproved && (
            <Card className="text-danger text-center mb-2">
              Please contact the office for attendance approval
            </Card>
          )}

          <Row>
            <Col md={6} className="mb-4">
              <ShortLinks />
            </Col>

            {context.allowedAccess(
              "stu_mob_upcoming_dayorder_view",
              "action_read"
            ) && (
              <Col md={6} className="mb-3">
                <UpcomingTimeTable upComing={true} />
              </Col>
            )}
          </Row>
        </div>
      </div>

      <MuiModalWindow open={showModal} onClose={(e) => setShowModal(false)}>
        <div>
          <img
            src={MOB_ICONS.BIRTHDAY}
            alt="Birthday Icon"
            style={{
              width: "100px", // Adjust the size of the circle as needed
              height: "100px",
              borderRadius: "50%", // Makes the image a circle
              objectFit: "cover", // Ensures the image covers the circle shape
              marginBottom: "20px", // Adds space between the image and the text
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
          <h2 style={{ fontFamily: "arial-black" }}>Happy Birthday!</h2>
          <h6 style={{ fontFamily: "arial-black" }}>
            {birthdayWish.template_msg}
          </h6>
        </div>
      </MuiModalWindow>

      <MuiModalWindow
        title="My Attendance Percentage"
        open={showPercentage}
        onClose={(e) => setShowPercentage(false)}
      >
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <AttendancePercentage show={true} />
          </Col>
        </Row>
      </MuiModalWindow>
    </>
  );
};
export default Home;
